$(document).ready(function() {
    
    // 1. Costruiamo l'array leggendo in modo sicuro i dati dall'HTML
    var validRanges = [];
    $('.authenticity-range-item').each(function() {
        var fromVal = parseInt($(this).attr('data-from'), 10);
        var toVal = parseInt($(this).attr('data-to'), 10);
        
        // Se i valori sono numeri validi, li salviamo nell'array
        if (!isNaN(fromVal) && !isNaN(toVal)) {
            validRanges.push({ from: fromVal, to: toVal });
        }
    });

    var authenticityYesTitle = $('.authenticity-yes-title').data('value');
    var authenticityYesText = $('.authenticity-yes-text').data('value');
    var authenticityYesImg = $('.authenticity-yes-img').data('value');
    var authenticityNoTitle = $('.authenticity-no-title').data('value');
    var authenticityNoText = $('.authenticity-no-text').data('value');
    var authenticityNoImg = $('.authenticity-no-img').data('value');
    
    // --- NUOVO CODICE: INTERCETTA IL SUCCESSO DELL'AJAX ---
    $(document).on('zg-notification', function(e, data) {
        // Se l'evento notifica il successo dell'invio form
        if (data && data.eventType === 'sendFormEmail') {
            // Applichiamo le classi per forzare subito lo switch dell'interfaccia
            $('#verification_form_component').addClass('form-sent');
            $('.thanks-notification').addClass('open-thanks');
        }
    });
    // ------------------------------------------------------

    // 2. Gestione dell'invio del form
    $('#verification_form_component').on('submit', function(e) {
        var $form = $(this);

        // Validazione di default del tuo tema
        if (!$form.valid()) {
            return;
        }

        var inputField = $('#verification').val().trim();
        var numericValue = parseInt(inputField, 10);
        var isAuthentic = false;

        // Controllo sui range appena generati
        if (validRanges.length > 0) {
            for (var i = 0; i < validRanges.length; i++) {
                if (numericValue >= validRanges[i].from && numericValue <= validRanges[i].to) {
                    isAuthentic = true;
                    break;
                }
            }
        }

        var $thanksContainer = $('.thanks-notification');
        var $formContainer = $('.product-verification');
        var $titleEl = $thanksContainer.find('.title');
        var $descEl = $thanksContainer.find('.nl_bottom');
        var $imgEl = $thanksContainer.find('.image_confirm');

        if (isAuthentic) {
            // PRODOTTO AUTENTICO
            e.preventDefault();
            e.stopImmediatePropagation(); 

            if ($titleEl.length) $titleEl.html( authenticityYesTitle );
            if ($descEl.length) $descEl.html(authenticityYesText);
            if ($imgEl.length) $imgEl.attr('src',authenticityYesImg);

            $form.addClass('form-sent');
            $thanksContainer.addClass('open-thanks');
            
        } else {
            // PRODOTTO DA VERIFICARE (la mail parte regolarmente)
            if ($titleEl.length) $titleEl.html(authenticityNoTitle);
            if ($descEl.length) $descEl.html(authenticityNoText);
            if ($imgEl.length) $imgEl.attr('src',authenticityNoImg);
            
            // L'AJAX partirà in automatico. Quando finisce e invia la mail, 
            // il listener 'zg-notification' che abbiamo aggiunto sopra 
            // applicherà la classe .form-sent istantaneamente.
        }
    });
});